/* eslint-disable @angular-eslint/directive-selector */
import { NgForOf } from '@angular/common';
import { Directive, inject, Input } from '@angular/core';

@Directive({
    selector: '[ngForTrackByProperty]',
    standalone: false
})
export default class TrackByPropertyDirective {
  private innerPropertyName = '';

  private readonly ngFor = inject(NgForOf<any>, { host: true });

  public constructor() {
    this.ngFor.ngForTrackBy = (_: number, item: any) => (this.innerPropertyName ? item[this.innerPropertyName] : item);
  }

  @Input('ngForTrackByProperty')
  public set propertyName(value: string | null) {
    this.innerPropertyName = value ?? '';
  }
}
